import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { NavigationService } from 'src/app/services/navigation.service';
import { LookupDataServiceService } from 'src/app/services/lookup-data-service.service';
import { RoleType } from 'src/app/enum/role-type';
import swal from 'sweetalert2';
import { UserdataService } from 'src/app/services/userdata.service';
import { NotificationService } from 'src/app/services/notification-service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-login-details',
  templateUrl: './login-details.component.html',
  styleUrls: ['./login-details.component.scss']
})
export class LoginDetailsComponent implements OnInit {
  data = [];
  dataSource = new MatTableDataSource(this.data);
  fullName: any;
  displayedColumns: string[] = [
    "firstName",
    "lastName",
    "email",
    "cellNumber",
    "role",
    "action"
  ];

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild("searchInput", { static: true }) searchInput: ElementRef;
  dataExcel: any = [];
  excelColumns: string[];
  filterValue: string;
  roleTypeEnum = RoleType;

  constructor(
    private LookupDataServiceService: LookupDataServiceService,
    private UserdataService: UserdataService,
    private toastr: NotificationService,
    private navigationService: NavigationService) { }

  ngOnInit() {
    this.getTableData();
  }


  getTableData() {
    this.LookupDataServiceService.getHCUserList().subscribe((result) => {
      this.data = [];
      this.dataExcel = [];
      this.data = result;
      this.dataExcel = result;
      // this.data = _.orderBy(this.data, ["id"], ["desc"]);
      this.dataSource = new MatTableDataSource(this.data);
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
    });
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.filterValue = filterValue;
    this.dataSource.filter = filterValue.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  clearFilter() {
    const inputElement = document.getElementById('filter-input') as HTMLInputElement;
    if (inputElement) {
      inputElement.value = '';
    }
    this.dataSource.filter = '';
    this.searchInput.nativeElement.value = "";
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
    this.dataSource.sort.active = '';
    this.dataSource.sort.direction = '';
    this.dataSource.sort.sortChange.emit({ active: '', direction: '' });
    this.getTableData();
  }

  goToLoginDetails(userId) {
    this.navigationService.goToLoginDetails(userId);
  }

  deleteUser(data) {
    let txt: string;

    this.fullName = `${data?.firstName ?? ''} ${data?.lastName ?? ''}`.trim();

    if (data.reachUserId != null) {
      txt = `The user <b style="color:black;">${this.fullName}</b> 
           will also be deactivated in the Prepaid Portal.<br>
           Do you want to continue?`;
    } else {
      txt = `Do you want to deactivate user 
           <b style="color:black;">${this.fullName}</b>?`;
    }

    const Yes = 'Yes';
    const No = 'No';
    swal.fire({
      html: txt,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#7D32DE',
      cancelButtonColor: '#23C00A',
      confirmButtonText: Yes,
      cancelButtonText: No,
    }).then((result) => {
      if (result.value) {
        this.UserdataService.deleteHCUser(data.userId).subscribe((result) => {
          if (result) {
            this.toastr.showSuccess("Deactivated Successfully");
            this.getTableData();
          } else {
            this.toastr.showError("Oops Something went wrong.");
          }
        });
      }
    });
  }

  resetPassword(data) {
    const title = 'Confirmation';
    let txt: string;
    if (data.reachUserId != null) {
      txt = 'Your password will also update in the Prepaid Portal. Do you want to reset?';
    }
    else {
      txt = 'Are you sure you want to reset your password?';
    }

    const Yes = 'Yes';
    const No = 'No';
    Swal.fire({
      title,
      text: txt,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#7D32DE',
      cancelButtonColor: '#23C00A',
      confirmButtonText: Yes,
      cancelButtonText: No,
    }).then((result) => {
      if (result.value) {
        this.UserdataService.resetPasswordForAmendCustomer(data.email, true).subscribe((res) => {
          if (res) {
            Swal.fire("Success!", "Password Changed Successfully", "success").then(() => {
              this.getTableData();
            })
          }
        });
      }
    });
  }

}
